import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../components/AuthProvider";
import { checkSessionProfileApi } from "../api/userApi";
import { CircularProgress, Box } from "@mui/material";
import { isDevAuthBypassEnabled } from "../helper/auth";
import { shouldRouteToOnboarding } from "../helper/onboardingHandoff";

const PublicRoute = () => {
  const {
    token,
    setUserEmail,
    setUserFirstName,
    setUserLastName,
    setToken,
    setRole,
  } = useAuth();
  const [isVerifying, setIsVerifying] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authenticatedDestination, setAuthenticatedDestination] = useState("/landing");

  useEffect(() => {
    // Prototype: only treat the in-memory Login session as authenticated.
    // Do not auto-login — Logout must be able to land on the Login page.
    if (isDevAuthBypassEnabled()) {
      setIsAuthenticated(Boolean(token));
      setIsVerifying(false);
      return;
    }

    checkSessionProfileApi()
      .then(res => {
        if (res && res.status === 200) {
          setUserFirstName(res.data.first_name);
          setUserLastName(res.data.last_name);
          setUserEmail(res.data.email);
          setToken("cookie-session");
          setAuthenticatedDestination(
            shouldRouteToOnboarding(res.data) ? "/onboarding" : "/landing"
          );
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
      })
      .finally(() => {
        setIsVerifying(false);
      });
  }, [setRole, setToken, setUserEmail, setUserFirstName, setUserLastName, token]);

  if (isVerifying) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return <>{!isAuthenticated ? <Outlet /> : <Navigate to={authenticatedDestination} />}</>;
};

export default PublicRoute;
